import React from "react";
/**
 * The React context object consumers may use to access the context of the
 * portal.
 */

var PortalContext = React.createContext({});
PortalContext.displayName = "PortalContext";
export default PortalContext;